import React from 'react';

export const Form = ({
  onSubmit,
  children,
  ...props
}: React.ComponentPropsWithRef<'form'>) => {
  return (
    // Disabling this line since this is the ONLY place where we can use <form />
    // eslint-disable-next-line no-restricted-syntax
    <form
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit?.(event);
      }}
      {...props}
    >
      {children}
    </form>
  );
};
